import React, {Component} from 'react';
import Paper from 'material-ui/Paper';

import PrivateRoute from '../route/PrivateRoute';
import PublicRoute from '../route/PublicRoute';
import Home from '../view/Home';
import SchedulerList from '../view/scheduler/list/SchedulerList';

const style = {
    minHeight: 100,
    margin: '64px 0'
};

class MainContent extends Component {
    render() {
        const { auth } = this.props;
        const { cookies } = this.props;

        return (
            <div>
                <Paper style={style} zDepth={0}>
                    <div>
                        <PublicRoute exact path="/" component={Home} auth={auth} logoff={this.props.logoff} />
                        <PublicRoute path="/login" component={Home} auth={auth} cookies={cookies} updateUser={this.props.updateUser}/>
                        <PrivateRoute path="/scheduler" component={SchedulerList} redirectTo="/" auth={Boolean(auth)}/>
                    </div>
                </Paper>
            </div>
        );
    }
}

export default MainContent;


// WEBPACK FOOTER //
// ./src/components/layout/MainContent.js